/* eslint-disable @typescript-eslint/naming-convention */
import { atom } from 'jotai';

import { currentVehicleAtom } from '../Vehicle/CurrentVehicle.atom';

export const utmValuesFromVehicle = atom(get => {
  return {
    utm_campaign: get(currentVehicleAtom)?.model.id,
    utm_term: get(currentVehicleAtom)?.heycarId,
    utm_content: get(currentVehicleAtom)?.details.registration,
    amount: get(currentVehicleAtom)?.pricing.price,
    vrm: get(currentVehicleAtom)?.details.registration,
    year: get(currentVehicleAtom)?.details.year,
    make: get(currentVehicleAtom)?.make.label,
    model: get(currentVehicleAtom)?.model.label,
    price: get(currentVehicleAtom)?.pricing.price,
    mileage: get(currentVehicleAtom)?.details.mileage,
    fuel: get(currentVehicleAtom)?.spec.fuelType,
    transmission: get(currentVehicleAtom)?.spec.gearbox,
    colour: get(currentVehicleAtom)?.spec.color,
    imageUrl: get(currentVehicleAtom)?.images[0]?.url,
  };
});
